import { render } from "./TaskCard.vue?vue&type=template&id=7b74cf59&scoped=true"
import script from "./TaskCard.vue?vue&type=script&lang=js"
export * from "./TaskCard.vue?vue&type=script&lang=js"

import "./TaskCard.vue?vue&type=style&index=0&id=7b74cf59&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-7b74cf59"

export default script